//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Motion.js";
import "../no/TaggedObject.js";
import "../no/Expression.js";
import "../Motion/Motion.SelectFieldData.js";
import "../Motion/Motion.ExpressionFunctionBuilder.js";
import "../no/ExternalFileReferenceAdapter.js";
import "../no/Expression.js";
import "../no/SelectObject.js";
let d=[[[1,"CorneringStiffness",0,"Expression",0],[1,"CorneringTableProfile",0,"Motion.SelectFieldData",0],[1,"FrictionCoefficient",0,"Expression",0],[0,"LateralForceType",1,0],[0,"Name",1,0],[1,"Radius",0,"Expression",0],[1,"RollingResistance",0,"Expression",0],[1,"VerticalDamping",0,"Motion.ExpressionFunctionBuilder",0],[1,"VerticalStiffness",0,"Motion.ExpressionFunctionBuilder",0]],[[[],"Validate",{R_:{result:''}},0,0],[["referenceObjectId"],"GetExternalFileReferenceAdapter",{R_:{adapter:"ExternalFileReferenceAdapter"}},1,0],[["referenceObjectId","adapter"],"SetExternalFileReferenceAdapter",{},2,0],[["adapter"],"GetExternalFileDefinitionKey",{R_:{externalFileDefinitionKey:''}},1,0],[["referenceObjectId","referenceType","externalFileSpec"],"EstablishReference",{R_:{adapter:"ExternalFileReferenceAdapter"}},3,0]],[]];
SPLM.Motion.TirePropertyBasicParameters = class extends SPLM.TaggedObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Motion.TirePropertyBasicParameters";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Motion.TirePropertyBasicParameters.CorneringType = Object.freeze({
    "Cornering" : "Cornering", "Carpet" : "Carpet"});

export default SPLM;